import { Heading } from '@chakra-ui/react'
import SendingPersonalizationBatchFormHandler from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardPersonalization/sendingPersonalizationBatch/SendingPersonalizationBatchFormHandler'

const SendingPersonalizationBatchPage = () => {
  return (
    <>
      <Heading size="md" mb={"2rem"}>
        Envoi lot de personalisation
      </Heading>
      <SendingPersonalizationBatchFormHandler />
    </>
  )
}

export default SendingPersonalizationBatchPage